import { Footnote, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import telegramIconImg from 'img/cloud-files-migrate/logo-telegram-icon.png';
import React, { memo } from 'react';

import styles from './CloudFilesMigrationPromo.css';

interface IProps {
    className?: string;
    onClick: () => void;
}

export const CloudFilesMigrationPromo = memo<IProps>(({ onClick, className }) => {
    return (
        <div className={classNames(styles.root, className)} onClick={onClick} data-qa-id="cloud-files-migration-promo">
            <div className={styles.logo}>
                <img src={telegramIconImg} alt="Логотип Telegram" />
            </div>
            <div className={styles.text}>
                <Title level="3" className={styles.title}>
                    Из Telegram в Облако
                </Title>
                <Footnote className={styles.footnote}>Сохраните фото и видео</Footnote>
            </div>
        </div>
    );
});

CloudFilesMigrationPromo.displayName = 'CloudFilesMigrationPromo';
